const english = {
  'TABLES.Column_Title_Name' : 'Name',
  'TABLES.Column_Title_Phone' : 'Phone',
  'TABLES.Column_Title_Email' : 'Email',
  'TABLES.Column_Title_Company' : 'Company',
  'TABLES.Column_Title_Supplier' : 'Supplier',
  'TABLES.Column_Title_User' : 'User',
  'TABLES.Column_Title_Time' : 'Time',
  'TABLES.Column_Title_JobType' : 'Job type',
  'TABLES.Column_Title_Roles' : 'Roles',
  'TABLES.Column_Title_Teams' : 'Teams',
  'TABLES.Column_Title_Type' : 'Type',
  'TABLES.Column_Title_Label' : 'Label',
  'TABLES.Column_Title_Title' : 'Title',
  'TABLES.Column_Title_Status' : 'Status',
  'TABLES.Column_Title_Description' : 'Description',
  'TABLES.Column_Title_ID' : 'ID',
  'TABLES.Column_Sorting_Tooltip_Ascending' : 'Click to sort ascending',
  'TABLES.Column_Sorting_Tooltip_Descending' : 'Click to sort descending',
  'TABLES.Column_Sorting_Tooltip_Cancel' : 'Click to cancel sorting',
  'TABLES.Column_Title_FileName' : 'File name',
  'TABLES.Column_Title_RoleName' : 'Role name',
  'TABLES.Column_Title_NumberRights': 'Number of rights',
  'TABLES.Column_Title_NumberRightsLibrary': 'Number of rights (Library)',
  'TABLES.Column_Title_NumberRightsApp': 'Number of rights (App)',
  'TABLES.Column_Title_NumberUsers' : 'Number of users',
  'TABLES.Column_Title_SupplierName' : 'Supplier name',
  'TABLES.Column_Title_Number' : 'Number',
  'TABLES.Column_Title_UsersNumber' : 'Users Number',
  'TABLES.Column_Title_KeyAmount' : 'Key amount',
  'TABLES.Column_Title_GroupName' : 'Group name',
  'TABLES.Column_Title_Key' : 'Key',
  'TABLES.Column_Title_Editable' : 'Editable',
  'TABLES.Column_Title_Records' : 'Records',
  'TABLES.Column_Title_Found' : 'Found',
  'TABLES.Column_Title_New' : 'New',
  'TABLES.Column_Title_Updated' : 'Updated',
  'TABLES.Column_Title_TeamName' : 'Team name',
  'TABLES.Column_Title_Head' : 'Head',
  'TABLES.Column_Title_NumbProjectManager' : 'Number of project managers',
  'TABLES.Column_Title_NumbDraftsMen' : 'Number of draftsmen',
  'TABLES.Column_Title_Image' : 'Image',
  'TABLES.Column_Title_Article' : 'Article',
  'TABLES.Column_Title_Color' : 'Color',
  'TABLES.Column_Title_NavisionNumb' : 'Navision №',
  'TABLES.Column_Title_OctacadNumb' : 'Octacad №',
  'TABLES.Column_Title_SupplierNumb' : 'Supplier article №',
  'TABLES.Column_Title_ContentLang' : 'Content language',
  'TABLES.Column_Title_Organizer' : 'Organizer',
  'TABLES.Column_Title_Price' : 'Price',
  'TABLES.Column_Title_SizeMinMax' : 'Size (sqm)',
  'TABLES.Column_Title_PricePer' : 'Price per sqm: (€)',
  'TABLES.Column_Title_Orientations' : 'Orientations',
  'TABLES.Column_Title_RuleType' : 'Rule type',
  'TABLES.Column_Title_StandSizeSqm' : 'Stand size (sqm)',
  'TABLES.Column_Title_Amount' : 'Amount',
  'TABLES.Column_Title_NumberStands' : 'Number of stands',
  'TABLES.Column_Title_NumberEquipment' : 'Number of equipment',
  'TABLES.Column_Title_NumberFlooring' : 'Number of flooring',
  'TABLES.Column_Title_Logo' : 'Logo',
  'TABLES.Column_Title_PrintingCompany' : 'Printing company',
  'TABLES.Column_Title_Leistungscode' : 'Service description',
  'TABLES.Column_Title_EPFertigungListe' : 'Single price production list',
  'TABLES.Column_Title_EPMontageWerkstatt' : 'Single price assembly in workshop',
  'TABLES.Column_Title_EPMontageStand' : 'Single price assembly on stand',
  'TABLES.Column_Title_Lettering' : 'Lettering',
  'TABLES.Column_Title_3dModel' : '3d model',
  'TABLES.Column_Title_Slug' : 'Slug',
  'TABLES.Column_Title_Action' : 'Action',
  'TABLES.Column_Title_EntryPoint': 'Entry point',
  'TABLES.Column_Title_ExhibitionTypes': 'Exhibition types',
  'FORM_RULES.Min_NewPassword' : 'Password must be at least { minLength } characters',
  'FORM_RULES.Required_NewPassword' : 'Please input new Password',
  'FORM_RULES.Required_ConfirmPassword' : 'Please confirm new password',
  'FORM_RULES.Required_ConfirmPasswordMatch' : 'The entered passworts do not match.',
  'FORM_RULES.Required_Name' : 'Please input name',
  'FORM_RULES.Required_ArticleEquipment' : 'Please input name',
  'FORM_RULES.Required_Surname' : 'Please input surname',
  'FORM_RULES.Required_Email' : 'The input E-mail is not valid',
  'FORM_RULES.Required_Choose': 'Please Choose ',
  'FORM_RULES.Required_ChooseType': 'Please choose type',
  'FORM_RULES.Required_ChooseColor': 'Please choose color',
  'FORM_RULES.Required_Phone' : 'Please input phone',
  'FORM_RULES.Required_Title' : 'Please input title',
  'FORM_RULES.Required_Number' : 'Please input number',
  'FORM_RULES.Required_Where' : 'Please choose where to change the time',
  'FORM_RULES.Required_Password' : 'Please input your Password!',
  'FORM_RULES.Required_RoleName' : 'Please input role name',
  'FORM_RULES.Required_Color' : 'Please input color',
  'FORM_RULES.Required_SupplierName' : 'Please input supplier name',
  'FORM_RULES.Required_Key' : 'Please input key',
  'FORM_RULES.Required_Article' : 'Please input article number',
  'FORM_RULES.Required_SupplierArticle' : 'Please input supplier article',
  'FORM_RULES.Required_OctacadNumb' : 'Please input octacad number',
  'FORM_RULES.Required_NavisionArticle' : 'Please input navision article',
  'FORM_RULES.Required_Price' : 'Please input price',
  'FORM_RULES.Required_StandName' : 'Please input stand name',
  'FORM_RULES.Required_MinSizeSqm' : 'Please input min size',
  'FORM_RULES.Required_MaxSizeSqm' : 'Please input max size',
  'FORM_RULES.Required_PricePerSqm' : 'Please input price',
  'FORM_RULES.Required_SizeMinMax' : 'Please input size',
  'FORM_RULES.Required_Amount' : 'Please input amount',
  'FORM_RULES.Required_RuleType' : 'Please input rule type',
  'FORM_RULES.Required_TeamName' : 'Please input team name',
  'FORM_RULES.Required_OrganizerName' : 'Please input organizer name',
  'FORM_RULES.Required_ExhibitionName': 'Please input exhibition type name',
  'FORM_RULES.Required_ExhibitionTypes': 'Please choose exhibition types',
  'FORM_RULES.Required_Leistungscode' : 'Please input leistungscode',
  'FORM_RULES.Required_EPFertigungListe' : 'Please input EP production list',
  'FORM_RULES.Required_EPMontageWerkstatt' : 'Please input EP assembly work shop',
  'FORM_RULES.Required_EPMontageStand' : 'Please input EP assembly stand',
  'FORM_RULES.Required_FreeCharactersAmount' : 'Please input free characters amount',
  'FORM_RULES.Required_AdditionalPrice' : 'Please input additional price',
  'FORM_RULES.Invalid_Phone': 'The input is not valid phone',
  'FORM_RULES.Required_Organizer': 'Please input organizer',
  'FORM_RULES.Required_PrintingCompany': 'Please input printing company',
  'FORM_RULES.Required_MaxCharacter': 'Maximum length 128 characters',
  'FORMS.Input_Label_Password' : 'Password',
  'FORMS.Input_Label_Login' : 'Login',
  'FORMS.Input_Label_NewPassword' : 'New password',
  'FORMS.Input_Label_ConfirmPassword' : 'Confirm new password',
  'FORMS.Input_Label_Language' : 'Language',
  'FORMS.Input_Label_Name' : 'Name',
  'FORMS.Input_Label_Surname' : 'Surname',
  'FORMS.Input_Label_Phone' : 'Phone',
  'FORMS.Input_Label_Email' : 'Email',
  'FORMS.Input_Label_Title' : 'Title',
  'FORMS.Input_Label_Number' : '№',
  'FORMS.Input_Label_Description' : 'Description',
  'FORMS.Input_Label_Status': 'Status',
  'FORMS.Input_Label_Lettering': 'Lettering',
  'FORMS.Input_Label_IntrfaceLanguage' : 'Please choose interface language',
  'FORMS.Input_Label_ContentLanguage' : 'Please choose content language',
  'FORMS.Input_Label_RoleName' : 'Role name',
  'FORMS.Input_Label_Color' : 'Color',
  'FORMS.Input_Label_BaseColor' : 'Material/Colour group',
  'FORMS.Input_Label_Role' : 'Role',
  'FORMS.Input_Label_SupplierName' : 'Supplier name',
  'FORMS.Input_Label_GroupName' : 'Group name',
  'FORMS.Input_Label_Key' : 'Key',
  'FORMS.Input_Label_EditableKey' : 'Editable key',
  'FORMS.Input_Label_Supplier' : 'Supplier',
  'FORMS.Input_Label_Head' : 'Head',
  'FORMS.Input_Label_TeamName' : 'Team name',
  'FORMS.Input_Label_Team' : 'Team',
  'FORMS.Input_Label_ProjectManagers' : 'Project managers',
  'FORMS.Input_Label_ConstructionManagers' : 'Construction managers',
  'FORMS.Input_Label_AutocadEngineers' : 'Autocad engineers',
  'FORMS.Input_Label_AssignedTeams' : 'Assigned teams',
  'FORMS.Input_Label_Type' : 'Type',
  'FORMS.Input_Label_Article' : 'Article',
  'FORMS.Input_Label_Images' : 'Images',
  'FORMS.Input_Label_SupplierArticle' : 'Supplier article №',
  'FORMS.Input_Label_OctacadArticle' : 'Octacad №',
  'FORMS.Input_Label_NavisionNumb' : 'Navision №',
  'FORMS.Input_Label_Price' : 'Price',
  'FORMS.Input_Label_StandName' : 'Stand name',
  'FORMS.Input_Label_MinSizeSqm' : 'Min size (sqm)',
  'FORMS.Input_Label_MaxSizeSqm' : 'Max size (sqm)',
  'FORMS.Input_Label_PricePerSqm' : 'Price per sqm (€)',
  'FORMS.Input_Label_Complexity' : 'Complexity',
  'FORMS.Input_Label_MinPrice' : 'Min price (€)',
  'FORMS.Input_Label_MaxPrice' : 'Max price (€)',
  'FORMS.Input_Label_Orientations' : 'Orientations',
  'FORMS.Input_Label_SignIn' : 'Sign in',
  'FORMS.Input_Label_StandSizeMinSqm' : 'Stand size min (sqm)',
  'FORMS.Input_Label_StandSizeMaxSqm' : 'Stand size max (sqm)',
  'FORMS.Input_Label_Amount' : 'Amount',
  'FORMS.Input_Label_StandRuleType' : 'Stand rule type',
  'FORMS.Input_Label_EquipmentName' : 'Equipment name',
  'FORMS.Input_Label_Equipment' : 'Equipment',
  'FORMS.Input_Label_AddText' : 'Add text',
  'FORMS.Input_Label_OrganizerName' : 'Organizer name',
  'FORMS.Input_Label_Organizer' : 'Organizer',
  'FORMS.Input_Label_EquipmentSuppliers' : 'Equipment suppliers',
  'FORMS.Input_Label_PrintHouseSuppliers' : 'Print house suppliers',
  'FORMS.Input_Label_FlooringSuppliers' : 'Flooring suppliers',
  'FORMS.Input_Label_Logo' : 'Logo',
  'FORMS.Input_Label_ExhibitionName' : 'Exhibition Type name',
  'FORMS.Input_Label_ExhibitionTypes' : 'Exhibition Types',
  'FORMS.Input_Label_Organizers' : 'Organizers',
  'FORMS.Input_Label_Materials' : 'Print materials',
  'FORMS.Input_Label_ColorsOracal' : 'Colors (Oracal)',
  'FORMS.Input_Label_AssemblyTypes' : 'Assembly Types',
  'FORMS.Input_Label_PrintingCompany' : 'Printing company',
  'FORMS.Input_Label_Leistungscode' : 'Leistungscode',
  'FORMS.Input_Label_EPFertigungListe' : 'EP Fertigung Liste',
  'FORMS.Input_Label_EPMontageWerkstatt' : 'EP Montage Werkstatt',
  'FORMS.Input_Label_EPMontageStand' : 'EP Montage Stand',
  'FORMS.Input_Label_FreeCharactersAmount' : 'Free characters amount',
  'FORMS.Input_Label_AdditionalPrice': 'Additional price',
  'FORMS.Input_Label_NameArticle' : 'Name of article',
  'FORMS.Input_Label_NameOfArticle': 'Name of article',
  'FORMS.Input_Label_Model3d': '3D Model',
  'FORMS.Input_Label_3DModelUrl': '3D model URL',
  'FORMS.Input_Label_Slug' : 'Slug',
  'FORMS.Input_Label_Action' : 'Action',
  'FORMS.Input_Label_EntryPoint': 'Entry point',
  'FORMS.Input_Label_JobType': 'Job type',
  'FORMS.Title_ChangePassword' : 'Change password',
  'FORMS.Title_SendPassword' : 'Send password',
  'FORMS.Title_AddUsers' : 'Add users',
  'FORMS.Title_ChooseType' : 'Choose type',
  'FORMS.Title_Text_Filters' : 'Filters',
  'FORMS.Title_Text_AddEquipmentRule' : 'Add new equipment rule',
  'FORMS.Title_Text_EditEquipmentRule' : 'Edit equipment rule',
  'FORMS.Title_Text_AddFlooringStand' : 'Add new flooring to the stand type',
  'FORMS.Title_Text_AddFlooringExhibition' : 'Add new flooring to the exhibition type',
  'FORMS.Title_Text_AddStandExhibition' : 'Add new stand type to the exhibition type',
  'FORMS.Title_Text_AddFlooringOrganizer' : 'Add new flooring to the organizer',
  'FORMS.Title_Text_AddStandOrganizer' : 'Add new stand type to the organizer',
  'FORMS.Title_Text_EditFile' : 'Edit file',
  'FORMS.Title_AddNote' : 'Add note',
  'FORMS.Title_Text_EditNote' : 'Edit note',
  'FORMS.Title_EditFile' : 'Edit file',
  'FORMS.Title_AddRoles' : 'Add roles',
  'FORMS.Title_CreateNewKey' : 'Create new key',
  'FORMS.Title_EditKey' : 'Edit key',
  'FORMS.Title_AddSupplier' : 'Add supplier',
  'FORMS.Title_SelectSupplier' : 'Select supplier',
  'FORMS.Title_SelectPrintingCompany' : 'Select printing company',
  'FORMS.Title_AddHead' : 'Add head',
  'FORMS.Title_AddProjectManagers' : 'Add project managers',
  'FORMS.Title_AddConstructionManagers' : 'Add construction managers',
  'FORMS.Title_AddAutocadEngineers' : 'Add autocad engineers',
  'FORMS.Title_AddTeams' : 'Add teams',
  'FORMS.Title_AddOrientations' : 'Add orientations',
  'FORMS.Title_CreateVariation' : 'Create variation',
  'FORMS.Title_EditVariation' : 'Edit variation',
  'FORMS.Title_AddSubstitude' : 'Add substitute',
  'FORMS.Title_ChooseEquipment' : 'Choose equipment',
  'FORMS.Title_UploadFile' : 'Upload file',
  'FORMS.Title_AddEquipmentSuppliers' : 'Add equipment suppliers',
  'FORMS.Title_AddPrintHouseSuppliers' : 'Add print house suppliers',
  'FORMS.Title_AddFlooringSuppliers' : 'Add flooring suppliers',
  'FORMS.Title_AddOrganizer': 'Add organizer',
  'FORMS.Title_SelectOrganizer' : 'Select organizer',
  'FORMS.Title_Text_AddEquipmentOrganizer' : 'Add new equipment articles',
  'FORMS.Title_Text_AddEquipmentExhibition' : 'Add new equipment to the exhibition type',
  'FORMS.Title_AddExhibitionTypes' : 'Add exhibition types',
  'FORMS.Title_AddOrganizers' : 'Add organizers',
  'FORMS.Title_AddGraphicMaterials' : 'Add print materials',
  'FORMS.Title_AddGraphicColorsOracal' : 'Add graphic colors (Oracal)',
  'FORMS.Title_AddAssemblyTypes' : 'Add assembly location',
  'FORMS.Title_EditGraphicRule' : 'Edit graphic prices',
  'FORMS.Title_AddPrintingCompany' : 'Add printing company',
  'FORMS.Title_CreateGraphicRule' : 'Create graphic rule',
  'FORMS.Title_Add3DModel': 'Add 3D model',
  'FORM_RULES.Required_3DModelUrl': 'Please input 3D model URL',
  'FORM_RULES.Invalid_Url': 'Please enter a valid URL (http/https)',
  'FORMS.Select_OptionLabel_NotAssigned' : 'Not assigned',
  'FORMS.Select_OptionLabel_TypeNotSet' : 'Type not set',
  'FORMS.Select_OptionLabel_English' : 'English',
  'FORMS.Select_OptionLabel_Deutsch' : 'Deutsch',
  'FORMS.Select_OptionLabel_ChooseColor' : 'Choose Color',
  'FORMS.Select_OptionLabel_Active' : 'Active',
  'FORMS.Select_OptionLabel_Blocked': 'Blocked',
  'FORMS.Select_OptionLabel_Full' : 'Full',
  'FORMS.Select_OptionLabel_CAD' : 'CAD',
  'FORMS.Input_Placeholder_Email' : 'Email',
  'FORMS.Input_Placeholder_Password' : 'Password',
  'FORMS.Input_Placeholder_Choose' : 'Please Choose',
  'FORMS.Input_Placeholder_ChooseColor' : 'Choose Color',
  'FORMS.Input_Placeholder_Name' : 'Name',
  'FORMS.Input_Placeholder_PleaseChose' : 'Please choose',
  'FORMS.Input_Placeholder_NotAssigned' : 'Not assigned',
  'FORMS.Headig_Text_AppRights' : 'App user rights',
  'FORMS.Headig_Text_LibraryRights' : 'Library - role rights',
  'FORMS.Headig_Text_Special' : 'Special',
  'FORMS.Headig_Text_User' : 'User',
  'FORMS.Headig_Text_Exhibitions' : 'Exhibitions',
  'FORMS.Headig_Text_Description' : 'Description',
  'FORMS.Headig_Text_Organizers' : 'Organizers',
  'FORMS.Button_Text_ApplyFilters' : 'Apply Filters',
  'FORMS.Button_Text_ResetFilters' : 'Reset filters',
  'FORMS.Button_Text_Filters' : 'Filters',
  'FORMS.Button_Text_Reset' : 'Reset',
  'SEARCH.Input_Placeholder_Table_User' : 'Search for name, email, phone',
  'SEARCH.Input_Placeholder_MultiSelect' : 'Search',
  'GLOBAL.Button_Text_Save' : 'Save',
  'GLOBAL.Button_Text_Send' : 'Send',
  'GLOBAL.Button_Text_SaveSend' : 'Save and send',
  'GLOBAL.Button_Text_SaveChanges' : 'Save changes',
  'GLOBAL.Button_Text_CreateNew' : 'Create new',
  'GLOBAL.Button_Text_Create' : 'Create',
  'GLOBAL.Button_Text_Cancel' : 'Cancel',
  'GLOBAL.Button_Text_Delete' : 'Delete',
  'GLOBAL.Button_Text_Remove' : 'Remove',
  'GLOBAL.Button_Text_Confirm' : 'Confirm',
  'GLOBAL.Button_Text_Upload' : 'Upload',
  'GLOBAL.Button_Text_Login' : 'Login',
  'GLOBAL.Button_Text_BackHome' : 'Back Home',
  'GLOBAL.Modal_Text_UserSendPass' : 'Are you sure you want to send a{ br }new password?',
  'GLOBAL.Modal_Text_RemoveText' : 'Are you sure you want to remove this { deleteObjectType }?',
  'GLOBAL.Modal_Text_DeleteText' : 'Are you sure you want to delete this { deleteObjectType }?',
  'GLOBAL.Modal_Text_ResetFilters' : 'Reset filters',
  'GLOBAL.Button_Text_AddNew' : 'Add new',
  'GLOBAL.Button_Text_AddKey' : 'Add key',
  'GLOBAL.Button_Text_Creat' : 'Create',
  'GLOBAL.Button_Text_DeleteGroup' : 'Delete group',
  'GLOBAL.Button_Text_DeleteItem' : 'Delete item',
  'GLOBAL.Button_Text_DeleteStand' : 'Delete stand',
  'GLOBAL.Button_Text_AddTranslation' : 'Add translation',
  'GLOBAL.Button_Text_AddMore' : 'Add more',
  'GLOBAL.Button_Text_AddFile' : 'Add file',
  'GLOBAL.Button_Text_AddDescription' : 'Add description',
  'GLOBAL.Button_Text_AddRule' : 'Add rule',
  'GLOBAL.Button_Text_EditRule' : 'Edit rule',
  'GLOBAL.Button_Text_Add' : 'Add',
  'GLOBAL.Button_Text_Edit' : 'Edit',
  'GLOBAL.Button_Text_DeleteFile' : 'Delete file',
  'GLOBAL.Button_Text_UploadNew' : 'Upload new',
  'GLOBAL.Button_Text_AddNote' : 'Add note',
  'GLOBAL.Button_Text_DeleteNote' : 'Delete note',
  'GLOBAL.Button_Text_DeleteOrganizer' : 'Delete organizer',
  'GLOBAL.Button_Text_AddOrganizer' : 'Add organizer',
  'GLOBAL.Text_NoData' : 'No Data',
  'GLOBAL.Text_Status_Disabled' : 'Disabled',
  'GLOBAL.Text_Status_InProgress' : 'In progress',
  'GLOBAL.Text_Status_Completed' : 'Completed',
  'GLOBAL.Text_AddImage' : 'Add image',
  'GLOBAL.Text_AddLogo' : 'Add logo',
  'GLOBAL.Text_Active' : 'Active',
  'GLOBAL.Text_Blocked' : 'Blocked',
  'GLOBAL.Text_Sqm': 'sq.m',
  'GLOBAL.Text_AllRights': 'All rights',
  'GLOBAL.Button_Text_Add3DModel': '3D model link',
  'GLOBAL.Text_3DModelUnavailable': '3D model unavailable',
  'GLOBAL.Text_LinkUploaded': 'Link uploaded',
  'MODAL.Button_Text_AddRole' : 'Add role',
  'MODAL.Button_Text_AddMore' : 'Add more',
  'MODAL.Button_Text_AddTeam' : 'Add team',
  'MODAL.Button_Text_AddSupplier' : 'Add supplier',
  'MODAL.Button_Text_AddOrientation' : 'Select orientation',
  'MODAL.Button_Text_AddExhibitionType': 'Add exhibition type',
  'MODAL.Button_Text_LogoSize' : 'min. 220 x 65',
  'MODAL.Button_Text_ImgSize' : 'min. 800 x 800',
  'MODAL.Title_Text_SuppliersFileImporting' : 'The suppliers file is importing…',
  'MODAL.Title_Text_SuppliersFileImported' : 'The suppliers file has been imported:',
  'ENTITY.Modal_Title_User' : 'User',
  'ENTITY.Modal_Title_Role' : 'Role',
  'ENTITY.Modal_Title_Supplier' : 'Supplier',
  'ENTITY.Modal_Title_Key' : 'Key',
  'ENTITY.Modal_Title_Group' : 'Group',
  'ENTITY.Modal_Title_Flooring' : 'Flooring',
  'ENTITY.Modal_Title_Equipment' : 'Equipment',
  'ENTITY.Modal_Title_Variation' : 'Variation',
  'ENTITY.Modal_Title_Stand' : 'Stand',
  'ENTITY.Modal_Title_StandEquipment' : 'Basic stand equipment',
  'ENTITY.Modal_Title_File' : 'File',
  'ENTITY.Modal_Title_Note' : 'Note',
  'ENTITY.Modal_Title_Team' : 'Team',
  'ENTITY.Modal_Title_Organizer' : 'Organizer',
  'ENTITY.Modal_Title_ExhibitionType' : 'Exhibition type',
  'ENTITY.Modal_Title_StandType' : 'Stand type',
  'ENTITY.Modal_Title_Graphic' : 'Graphic',
  'ENTITY.Modal_Title_GraphicRule': 'Graphic rule',
  'ENTITY.Modal_Title_Permission': 'Permission',
  'MENUS_DROP.Label_Users' : 'Users',
  'MENUS_DROP.Label_Logout' : 'Logout',
  'MENUS_DROP.Label_Edit' : 'Edit',
  'MENUS_DROP.Label_SendPass' : 'Send password',
  'MENUS_DROP.Label_Delete' : 'Delete',
  'MENUS_DROP.Label_Organizers' : 'Organizers',
  'MENUS_DROP.Label_Suppliers' : 'Suppliers',
  'MENUS_DROP.Label_Teams' : 'Teams',
  'MENUS_DROP.Label_StandTypes' : 'Stand types',
  'MENUS_DROP.Label_Equipment' : 'Equipment',
  'MENUS_DROP.Label_Flooring' : 'Flooring',
  'MENUS_DROP.Label_Settings' : 'Settings',
  'MENUS_DROP.Label_MyProfile' : 'My profile',
  'MENUS_DROP.Label_UploadIcon' : 'Upload icon',
  'MENUS_DROP.Label_MakeDefault' : 'Make default',
  'MENUS_DROP.Label_Permissions' : 'Permissions',
  'NAVBAR_PAGES.Label_Overview' : 'Details',
  'NAVBAR_PAGES.Label_Users' : 'Users',
  'NAVBAR_PAGES.Label_UserRoles' : 'User roles',
  'NAVBAR_PAGES.Label_VariableLists' : 'Variable list',
  'NAVBAR_PAGES.Label_Variations' : 'Variations',
  'NAVBAR_PAGES.Label_Substitude' : 'Substitute article',
  'NAVBAR_PAGES.Label_Equipments' : 'Equipment',
  'NAVBAR_PAGES.Label_Equipment' : 'Equipment',
  'NAVBAR_PAGES.Label_Floorings' : 'Flooring',
  'NAVBAR_PAGES.Label_Flooring' : 'Flooring',
  'NAVBAR_PAGES.Label_Files' : 'Files',
  'NAVBAR_PAGES.Label_Notes' : 'Notes',
  'NAVBAR_PAGES.Label_Organizers' : 'Organizers',
  'NAVBAR_PAGES.Label_ExhibitionTypes' : 'Exhibition types',
  'NAVBAR_PAGES.Label_StandTypes' : 'Stand types',
  'NAVBAR_PAGES.Label_GraphicRules' : 'Graphic rules',
  'NAVBAR_PAGES.Label_Rules' : 'Rules',
  'NAVBAR_PAGES.Label_Permissions' : 'Permissions (Developer only)',
  'BREADCRUMBS.Label_Users' : 'Users',
  'BREADCRUMBS.Label_Roles' : 'User roles',
  'BREADCRUMBS.Label_Create' : 'Create',
  'BREADCRUMBS.Label_Suppliers' : 'Suppliers',
  'BREADCRUMBS.Label_VariableLists' : 'Variable list',
  'BREADCRUMBS.Label_Teams' : 'Teams',
  'BREADCRUMBS.Label_Flooring' : 'Flooring',
  'BREADCRUMBS.Label_Equipment' : 'Equipment',
  'BREADCRUMBS.Label_Variations' : 'Variations',
  'BREADCRUMBS.Label_Substitude' : 'Substitute article',
  'BREADCRUMBS.Label_StandTypes' : 'Stands types',
  'BREADCRUMBS.Label_Equipments' : 'Equipments',
  'BREADCRUMBS.Label_Floorings' : 'Floorings',
  'BREADCRUMBS.Label_Files' : 'Files',
  'BREADCRUMBS.Label_Notes' : 'Notes',
  'BREADCRUMBS.Label_Organizers' : 'Organizers',
  'BREADCRUMBS.Label_Exhibitions' : 'Exhibition types',
  'BREADCRUMBS.Label_ExhibitionCreate' : 'Create exhibition type',
  'BREADCRUMBS.Label_GraphicRules' : 'Graphic rules',
  'BREADCRUMBS.Label_Rules' : 'Rules',
  'BREADCRUMBS.Label_Permissions' : 'Permissions',
  'PAGES.Title_CreateGroup' : 'Create Group',
  'PAGES.Title_Dashboard' : 'Dashboard',
  'PAGES.Title_Users' : 'Users',
  'PAGES.Title_CreateUser' : 'Create User',
  'PAGES.Title_CreateRole' : 'Create User Role',
  'PAGES.Title_CreateSupplier' : 'Create Supplier',
  'PAGES.Title_CreateFlooring' : 'Create Flooring',
  'PAGES.Title_CreateEquipment' : 'Create equipment article',
  'PAGES.Title_CreateTeam' : 'Create Team',
  'PAGES.Title_Suppliers' : 'Suppliers',
  'PAGES.Title_Settings' : 'Settings',
  'PAGES.Title_Teams' : 'Teams',
  'PAGES.Title_Flooring' : 'Flooring',
  'PAGES.Title_Equipment' : 'Equipment',
  'PAGES.Title_StandTypes' : 'Stand Types',
  'PAGES.Title_CreateStand' : 'Create Stand',
  'PAGES.Title_Organizers' : 'Organizers',
  'PAGES.Title_CreateOrganizer' : 'Create Organizer',
  'PAGES.Title_Exhibitions' : 'Exhibition Types',
  'PAGES.Title_CreateExhibition' : 'Create Exhibition Type',
  'PAGES.Title_CreateGraphicRules' : 'Create Graphic Rules',
  'PAGES.Title_Permissions' : 'Permissions',
  'PAGES.Title_CreatePermission' : 'Create Permission',
  'PAGES.Text_404' : 'Sorry, the page you searched for does not exist.',
  'PAGES.Text_403' : 'Sorry, you do not have permission to access this page.',
  'CARD.Info_List_BaseColor' : 'Color group',
  'CARD.Info_List_Type' : 'Material group',
  'CARD.Info_List_Supplier' : 'Supplier',
  'CARD.Info_List_OctacadNumb' : 'Octacad №',
  'CARD.Info_List_SupplierNumb' : 'Supplier article №',
  'CARD.Info_List_NavisionNumb' : 'Navision №',
  'CARD.Info_List_Size' : 'Size',
  'CARD.Info_List_PricePer' : 'Price per sqm',
  'CARD.Info_List_Default' : 'Default',
  'STANDTYPE.Equipment_Rule_EQ' : 'Equal',
  'STANDTYPE.Equipment_Rule_GTE' : 'Greater than/equal',
  'STANDTYPE.Equipment_Rule_LTE' : 'Less than/equal ',
  'STANDTYPE.Equipment_Rule_BETWEEN' : 'Between',
  'VARIABLE.Label_EMPTY' : '! NO TRANSLATION !',
  'USER.Button_Text_Delete' : 'Delete User',
  'ROLE.Button_Text_Delete' : 'Delete Role',
  'SUPPLIER.Button_Text_Delete' : 'Delete Supplier',
  'SUPPLIER.Button_Text_Import' : 'Import suppliers',
  'TEAM.Button_Text_Delete' : 'Delete Team',
  'ORGANIZER.Button_Text_Delete' : 'Delete Organizer',
  'EXHIBITION.Button_Text_Delete' : 'Delete exhibition type',
  'GRAPHIC.Button_Text_Delete' : 'Delete graphic',
  'PERMISSION.Button_Text_Delete' : 'Delete Permission',
  'PERMISSION.Error_AccessDenied' : 'Access denied',
  'PERMISSION.Error_FailedToLoad' : 'Failed to load user permissions',
  'PERMISSION.Error_NoPermission' : 'You do not have permission to perform this action',
  'PERMISSION.Error_NoAccessToSystem' : 'You do not have access to the system. Please contact your administrator.',
  'PERMISSION.Error_NoAccessToAnyPage' : 'You do not have access to any page in the system. Please contact your administrator.',
  'TABLES.Column_Title_Sender' : 'Sender',
  'TABLES.Column_Title_StandNumber' : 'Stand number',
  'TABLES.Column_Title_Changes' : 'Changes',
  'TABLES.Column_Title_Received' : 'Received',
  'TABLES.Column_Title_Confidence' : 'Confidence',
  'TABLES.Column_Title_ApprovedBy' : 'Approved by',
  'TABLES.Column_Title_ApprovedAt' : 'Approved at',
  'FORM_RULES.Required_EventName' : 'Please input event name',
  'FORM_RULES.Required_CompanyName' : 'Please input company name',
  'FORM_RULES.Required_StandNumber' : 'Please input stand number',
  'FORM_RULES.Required_Item' : 'Please input item name',
  'FORMS.Input_Label_Sender' : 'Sender',
  'FORMS.Input_Label_ReceivedAt' : 'Received at',
  'FORMS.Input_Label_Subject' : 'Subject',
  'FORMS.Input_Label_Confidence' : 'Confidence',
  'FORMS.Input_Label_EventName' : 'Event',
  'FORMS.Input_Label_CompanyName' : 'Company name',
  'FORMS.Input_Label_StandNumber' : 'Stand number',
  'FORMS.Input_Label_AISummary' : 'AI summary',
  'FORMS.Input_Label_AIReason' : 'AI reason',
  'FORMS.Input_Label_OriginalEmail' : 'Original email',
  'FORMS.Input_Label_Item' : 'Item',
  'FORMS.Input_Label_Flooring' : 'Flooring',
  'FORMS.Input_Label_CarpetColor' : 'Carpet color',
  'FORMS.Input_Label_ManagerNote' : 'Manager note',
  'FORMS.Input_Label_ReceivedDate' : 'Received date',
  'GLOBAL.Button_Text_Approve' : 'Approve',
  'GLOBAL.Button_Text_ResetData' : 'Reset data',
  'MENUS_DROP.Label_CommunicationBoard' : 'Communication Board',
  'NAVBAR_PAGES.Label_CommunicationInbox' : 'Inbox',
  'NAVBAR_PAGES.Label_CommunicationPending' : 'Ready to Confirm',
  'NAVBAR_PAGES.Label_CommunicationUnidentified' : 'Need Match',
  'NAVBAR_PAGES.Label_CommunicationAudit' : 'History',
  'BREADCRUMBS.Label_CommunicationBoard' : 'Communication Board',
  'PAGES.Title_CommunicationBoard' : 'Communication Board',
  'permission_group_communication_board' : 'Communication Board',
  'permission_view_communication_board' : 'View Communication Board',
  'permission_edit_communication_board_raw' : 'Edit Communication Board raw data',
  'permission_change_communication_board_status' : 'Approve Communication Board changes',
  'COMMUNICATION.Status_Pending' : 'Ready to confirm',
  'COMMUNICATION.Status_Unidentified' : 'Needs match',
  'COMMUNICATION.Status_Approved' : 'Approved',
  'COMMUNICATION.Title_EmailChange' : 'Review email',
  'COMMUNICATION.Title_AuditEntry' : 'History entry',
  'COMMUNICATION.Title_DailySummary' : 'Daily summary by client',
  'COMMUNICATION.Title_OverallClientSummary' : 'Clients needing attention',
  'COMMUNICATION.Title_Filters' : 'Communication filters',
  'COMMUNICATION.Section_EmailMeta' : 'Email metadata',
  'COMMUNICATION.Section_Matching' : 'Matching',
  'COMMUNICATION.Section_AIContext' : 'AI context',
  'COMMUNICATION.Section_AIContextSecondary' : 'View original email',
  'COMMUNICATION.Section_RequestGroups' : 'AI-parsed email items',
  'COMMUNICATION.Section_RequestGroupsHint' : 'Shows the original parsed items from the email, including notes and confidence, grouped by stand before manager edits.',
  'COMMUNICATION.Section_RequestGroupsHintFallback' : 'Shows fallback suggestions from the latest AI parse because structured email requests are not available yet.',
  'COMMUNICATION.Section_FinalChanges' : 'Final changes',
  'COMMUNICATION.Section_Audit' : 'Audit trail',
  'COMMUNICATION.Section_FutureActions' : 'Future actions',
  'COMMUNICATION.Preview_QuestionsOverview' : 'Open questions',
  'COMMUNICATION.Preview_QuestionsWorking' : 'Customer clarifications',
  'COMMUNICATION.Preview_QuestionsWorkingHint' : 'Handle customer clarifications here before final approval. They may change the confirmed equipment set.',
  'COMMUNICATION.Preview_QuestionsResult' : 'Clarification outcome',
  'COMMUNICATION.Preview_QuestionsResultHint' : '{ reviewed } reviewed / { questions } total clarifications before approval.',
  'COMMUNICATION.Preview_Logistics' : 'Logistics overview',
  'COMMUNICATION.Preview_LogisticsExtracted' : 'Items extracted from email',
  'COMMUNICATION.Preview_LogisticsExtractedHint' : 'Shows the original parsed items before manager edits.',
  'COMMUNICATION.Preview_LogisticsExtractedHintFallback' : 'Shows fallback suggestions from the latest AI parse before manager edits.',
  'COMMUNICATION.Preview_LogisticsFinal' : 'Final logistics overview',
  'COMMUNICATION.Preview_LogisticsFinalHint' : 'Reflects the current confirmed changes.',
  'COMMUNICATION.Preview_OrderChangeAdd' : 'Change: { item }, total { qty } pcs{ color }',
  'COMMUNICATION.Preview_OrderChangeRemove' : 'Change: { item }, remove { qty } pcs{ color }',
  'COMMUNICATION.Preview_OrderChangeChange' : 'Change: { item }, adjust { qty } pcs{ color }',
  'COMMUNICATION.Preview_OrderChangeFlooring' : 'Change: carpet color { color }',
  'COMMUNICATION.Preview_ItemFromEmail' : 'Item from email',
  'COMMUNICATION.Preview_Product' : 'Equipment',
  'COMMUNICATION.Preview_TotalQty' : 'Total qty',
  'COMMUNICATION.Preview_EmailDate' : 'Email date',
  'COMMUNICATION.Summary_Inbox' : 'Open emails',
  'COMMUNICATION.Summary_Pending' : 'Ready to confirm',
  'COMMUNICATION.Summary_Unidentified' : 'Need match',
  'COMMUNICATION.Summary_Approved' : 'Approved today',
  'COMMUNICATION.Summary_ParserProcessed' : 'Processed by parser today',
  'COMMUNICATION.Summary_ManagerApproved' : 'Manager approved today',
  'COMMUNICATION.Placeholder_Search' : 'Search sender, subject, event, company, stand',
  'COMMUNICATION.Placeholder_FilterEvent' : 'e.g. AAA Heilbronn 2026',
  'COMMUNICATION.Placeholder_FilterSender' : 'e.g. anna@example.com or Messeprojekt',
  'COMMUNICATION.Placeholder_FilterCompany' : 'e.g. BLOCK Transformatoren',
  'COMMUNICATION.Placeholder_FilterStand' : 'e.g. B-330',
  'COMMUNICATION.Placeholder_FilterDate' : 'DD.MM.YYYY',
  'COMMUNICATION.ReadOnly_Label' : 'Edit requires permission',
  'COMMUNICATION.ReadOnly_Audit' : 'Audit is read-only',
  'COMMUNICATION.PreviewMode_Message' : 'Preview only: edits stay local in this drawer.',
  'COMMUNICATION.PreviewMode_ResetNote' : 'Changes are not saved yet and reset when you close the drawer. Saving and approval will be enabled in the next phase.',
  'COMMUNICATION.PreviewMode_PageNote' : 'Presentation mode: board actions are interactive, while drawer edits stay preview-only for now.',
  'COMMUNICATION.Demo_MultiStandBadge' : 'Demo multi-stand',
  'COMMUNICATION.Demo_MultiStandNote' : 'Demonstration email for multi-stand UI validation. Real backend emails with multiple stands have not been received yet, so this example is intentionally kept in the board.',
  'COMMUNICATION.Reset_Title' : 'Reset Communication Board data?',
  'COMMUNICATION.Reset_Text' : 'This will clear local demo state and restore the seeded mock emails.',
  'COMMUNICATION.Message_Saved' : 'Communication task saved',
  'COMMUNICATION.Message_Approved' : 'Communication task approved',
  'COMMUNICATION.TabTooltip_Inbox' : 'All open emails that still need to be processed.',
  'COMMUNICATION.TabTooltip_Pending' : 'Emails with a match that only need review and approval.',
  'COMMUNICATION.TabTooltip_Unidentified' : 'Emails without a clear event, customer, or stand match.',
  'COMMUNICATION.TabTooltip_Audit' : 'Processed communication tasks, including approvals and items marked as not relevant.',
  'COMMUNICATION.Help_Inbox' : 'All open emails that still need to be processed.',
  'COMMUNICATION.Help_Pending' : 'Emails with a recognized match that only need review and approval.',
  'COMMUNICATION.Help_Unidentified' : 'Emails without a clear event, customer, or stand assignment.',
  'COMMUNICATION.Help_Audit' : 'Processed communication tasks, including approvals and items marked as not relevant.',
  'COMMUNICATION.Table_Email' : 'Email',
  'COMMUNICATION.Table_EventCompany' : 'Event / Client',
  'COMMUNICATION.Table_Stand' : 'Stand',
  'COMMUNICATION.Table_Changes' : 'Changes',
  'COMMUNICATION.Table_Questions' : 'Questions',
  'COMMUNICATION.Table_NextStep' : 'Next step',
  'COMMUNICATION.Table_Received' : 'Received',
  'COMMUNICATION.Table_ProcessedBy' : 'Processed by',
  'COMMUNICATION.Table_ProcessedAt' : 'Processed at',
  'COMMUNICATION.Table_Action' : 'Action',
  'COMMUNICATION.Results_Inbox' : '{ total } open emails in total, { visible } in this view',
  'COMMUNICATION.Results_Audit' : '{ total } processed items in total, { visible } in this view',
  'COMMUNICATION.Hint_RowClickOpen' : 'Click a row to open the review workflow',
  'COMMUNICATION.Hint_RowClickWorkflow' : 'Click to open the review workflow',
  'COMMUNICATION.Filter_Event' : 'Event',
  'COMMUNICATION.Text_NoQuestions' : 'No questions',
  'COMMUNICATION.Text_MultiStand' : 'Multi-stand',
  'COMMUNICATION.Text_ChangesCount' : '{ count } changes',
  'COMMUNICATION.Text_ChangesMore' : '+{ count } more',
  'COMMUNICATION.Text_QuestionsCount' : '{ count } questions',
  'COMMUNICATION.Text_NoExtractedChanges' : 'No extracted changes found for this email.',
  'COMMUNICATION.Text_NoFinalChanges' : 'No confirmed changes yet.',
  'COMMUNICATION.Text_QuestionsSummary' : '{ open } open / { questions } total',
  'COMMUNICATION.Info_OpenClarification' : '{ count } open clarification',
  'COMMUNICATION.Info_OpenClarificationPlural' : '{ count } open clarifications',
  'COMMUNICATION.Info_NeedsMatch' : 'Needs match',
  'COMMUNICATION.Info_NotRelevant' : 'Not relevant',
  'COMMUNICATION.Info_SpamSignal' : 'Spam signal',
  'COMMUNICATION.Source_Label' : 'Source',
  'COMMUNICATION.Source_AiFallback' : 'AI extracted',
  'COMMUNICATION.TopClients_OpenQuestions' : '{ open } open questions',
  'COMMUNICATION.TopClients_NeedMatch' : '{ count } need match',
  'COMMUNICATION.TopClients_ToReview' : '{ count } to review',
  'COMMUNICATION.TopClients_EmailCount' : '{ total } email',
  'COMMUNICATION.TopClients_EmailCountPlural' : '{ total } emails',
  'COMMUNICATION.TopClients_Unassigned' : 'Unassigned',
  'COMMUNICATION.TopClients_EmptyAttention' : 'No clients need attention',
  'COMMUNICATION.TopClients_MoreAttention' : '+ { count } more clients needing attention',
  'COMMUNICATION.Info_ItemsCount' : '{ count } item',
  'COMMUNICATION.Info_ItemsCountPlural' : '{ count } items',
  'COMMUNICATION.Info_ChipQuestionsSingle' : '1 question',
  'COMMUNICATION.Info_ChipQuestions' : '{ count } questions',
  'COMMUNICATION.Info_StandGroupsCount' : '{ count } stand',
  'COMMUNICATION.Info_StandGroupsCountPlural' : '{ count } stands',
  'COMMUNICATION.NextStep_Match' : 'Check matching',
  'COMMUNICATION.NextStep_Review' : 'Review changes',
  'COMMUNICATION.NextStep_History' : 'View history',
  'COMMUNICATION.Button_View' : 'View',
  'COMMUNICATION.Button_Open' : 'Open',
  'COMMUNICATION.Button_StartMatch' : 'Check matching',
  'COMMUNICATION.Button_StartReview' : 'Review changes',
  'COMMUNICATION.Button_Back' : 'Back',
  'COMMUNICATION.Button_BackToStep1' : 'Back to Step 1',
  'COMMUNICATION.Button_BackToStep2' : 'Back to Step 2',
  'COMMUNICATION.Button_Next' : 'Next',
  'COMMUNICATION.Button_ContinueToStep2' : 'Continue to Step 2',
  'COMMUNICATION.Button_ContinueToStep3' : 'Continue to Step 3',
  'COMMUNICATION.Button_SaveAndClose' : 'Save and close',
  'COMMUNICATION.Button_ChooseAnother' : 'Change',
  'COMMUNICATION.Button_AddChange' : 'Add change',
  'COMMUNICATION.Button_MarkNotRelevant' : 'Mark as not relevant',
  'COMMUNICATION.Button_OpenInMyStand' : 'Open stand in myStand',
  'COMMUNICATION.Button_ReplyToCustomer' : 'Reply to customer',
  'COMMUNICATION.Button_AddStandUpdate' : 'Add stand update',
  'COMMUNICATION.Button_AddManagerNote' : 'Add manager note',
  'COMMUNICATION.Action_StandUpdate' : 'Stand update',
  'COMMUNICATION.Action_ManagerNote' : 'Manager note',
  'COMMUNICATION.Button_AddQuestion' : 'Add question',
  'COMMUNICATION.Button_CollapseEmail' : 'Collapse email',
  'COMMUNICATION.Button_ExpandEmail' : 'Expand email',
  'COMMUNICATION.Button_ShowAllChanges' : 'Show all { count } changes',
  'COMMUNICATION.Button_CollapseChanges' : 'Collapse changes',
  'COMMUNICATION.Warning_UnsavedChangesConfirm' : 'You have unsaved changes in this review. Discard them and continue?',
  'COMMUNICATION.Audit_Outcome' : 'Outcome',
  'COMMUNICATION.Audit_Reason' : 'Reason',
  'COMMUNICATION.AuditOutcome_Approved' : 'Approved',
  'COMMUNICATION.AuditOutcome_Dismissed' : 'Marked as not relevant',
  'COMMUNICATION.NotRelevantSummary_Title' : 'Not relevant outcome',
  'COMMUNICATION.NotRelevantSummary_Hint' : 'This email was removed from the operational queue and stored in history instead of going through the review workflow.',
  'COMMUNICATION.EquipmentSuggestion_Badge' : 'AI suggestion',
  'COMMUNICATION.EquipmentSuggestion_ConfirmedBadge' : 'Confirmed',
  'COMMUNICATION.EquipmentSuggestion_ChangedBadge' : 'Changed',
  'COMMUNICATION.EquipmentSuggestion_Pending' : 'Confirm this suggestion or change it.',
  'COMMUNICATION.EquipmentSuggestion_Confirmed' : 'Suggestion confirmed.',
  'COMMUNICATION.EquipmentSuggestion_Changed' : 'Another item selected.',
  'COMMUNICATION.EquipmentSuggestion_PendingSummary' : '{ count } AI suggestions still need confirmation.',
  'COMMUNICATION.QuestionStatus_Open' : 'Open',
  'COMMUNICATION.QuestionStatus_Reviewed' : 'Reviewed',
  'COMMUNICATION.Field_Question' : 'Question',
  'COMMUNICATION.Field_Clarification' : 'Clarification',
  'COMMUNICATION.Field_QuestionStatus' : 'Question status',
  'COMMUNICATION.Validation_Question' : 'Please enter a question',
  'COMMUNICATION.Validation_SelectEquipmentOrDelete' : 'Choose equipment from catalog or delete this row.',
  'COMMUNICATION.Validation_SelectEquipmentForItemOrDelete' : 'Match "{ item }" from catalog or delete this row.',
  'COMMUNICATION.Match_NotReady' : 'This email stays in Need Match until event, company, and stand are filled in.',
  'COMMUNICATION.Warning_MatchRequired' : 'Approval is not possible until event, company, and stand are confirmed.',
  'COMMUNICATION.Warning_OpenQuestions' : 'There are still open questions for this email.',
  'COMMUNICATION.Warning_OpenQuestionsNonBlocking' : 'Open questions can stay open. They do not block approval.',
  'COMMUNICATION.Warning_OpenQuestionsCompact' : 'Open questions can stay open. They do not block approval.',
  'COMMUNICATION.Step_Matching_Title' : '1. Check matching',
  'COMMUNICATION.Step_Matching_Help' : 'Confirm event, company, and stand before the email moves to Ready to Confirm.',
  'COMMUNICATION.Step_Changes_Title' : '2. Review changes',
  'COMMUNICATION.Step_Changes_Help' : 'Check the parsed equipment changes and customer clarifications, then correct them if needed.',
  'COMMUNICATION.Step_Questions_Title' : '3. Review and approve',
  'COMMUNICATION.Workflow_StatusLabel' : 'Workflow status',
  'COMMUNICATION.Step_Questions_Help' : 'Review the final logistics result and question outcome before approval.',
  'COMMUNICATION.StepStatus_Ready' : 'Ready',
  'COMMUNICATION.StepStatus_NeedsMatch' : 'Needs match',
  'COMMUNICATION.StepStatus_CompleteStep1First' : 'Complete step 1 first',
  'COMMUNICATION.StepStatus_CompleteStep2First' : 'Complete step 2 first',
  'COMMUNICATION.StepStatus_ReviewCount' : '{ count } to review',
  'COMMUNICATION.StepStatus_Reviewed' : 'Reviewed',
  'COMMUNICATION.StepStatus_PendingCount' : '{ count } pending',
  'COMMUNICATION.StepStatus_NoPending' : 'No pending',
  'COMMUNICATION.StepStatus_NoExtractedChanges' : 'No extracted changes',
  'COMMUNICATION.StepStatus_OpenCount' : '{ count } open',
  'COMMUNICATION.StepStatus_NoQuestions' : 'No questions',
  'COMMUNICATION.StepStatus_FinalCheck' : 'Final check',
  'COMMUNICATION.StepStatus_ReadyToApprove' : 'Ready to approve',
  'COMMUNICATION.Confidence_High' : 'High match',
  'COMMUNICATION.Confidence_Medium' : 'Check match',
  'COMMUNICATION.Confidence_Low' : 'Low match',
  'COMMUNICATION.WorkState_Label' : 'Work state',
  'COMMUNICATION.WorkState_Untouched' : 'Untouched',
  'COMMUNICATION.WorkState_InProgress' : 'In progress',
  'COMMUNICATION.WorkState_Approved' : 'Approved',
  'COMMUNICATION.Status_Dismissed' : 'Dismissed',
  'COMMUNICATION.WorkState_LastTouched' : 'Last touched { date }',
  'COMMUNICATION.WorkState_Placeholder' : 'Local concept preview until backend ownership state is available.',
  'COMMUNICATION.RequestStatus_Pending' : 'Pending',
  'COMMUNICATION.RequestStatus_Unidentified' : 'Unidentified',
  'COMMUNICATION.RequestStatus_Approved' : 'Approved',
  'COMMUNICATION.RequestStatus_Rejected' : 'Rejected',
  'COMMUNICATION.RequestStatus_Cancelled' : 'Cancelled',
  'COMMUNICATION.RequestGroup_ByStand' : 'Grouped by stand',
  'COMMUNICATION.RequestGroup_StandFallback' : 'Stand not assigned yet',
  'COMMUNICATION.RequestGroup_EventFallback' : 'Event not assigned',
  'COMMUNICATION.RequestGroup_CompanyFallback' : 'Company not assigned',
  'COMMUNICATION.RequestGroup_GroupSingle' : '{ count } stand group',
  'COMMUNICATION.RequestGroup_Groups' : '{ count } stand groups',
  'COMMUNICATION.RequestGroup_ParsedItemSingle' : '{ count } parsed item',
  'COMMUNICATION.RequestGroup_ParsedItems' : '{ count } parsed items',
  'COMMUNICATION.RequestGroup_ItemSingle' : '{ count } item',
  'COMMUNICATION.RequestGroup_Items' : '{ count } items',
  'COMMUNICATION.RequestGroup_QuestionSingle' : '{ count } question',
  'COMMUNICATION.RequestGroup_Questions' : '{ count } questions',
  'COMMUNICATION.RequestGroup_UnidentifiedSingle' : '{ count } unidentified',
  'COMMUNICATION.RequestGroup_Unidentified' : '{ count } unidentified',
  'COMMUNICATION.RequestGroup_SectionReview' : 'Parsed changes',
  'COMMUNICATION.RequestGroup_SectionReviewHint' : 'These parsed order items continue through manager review and approval.',
  'COMMUNICATION.RequestGroup_SectionUnidentified' : 'Need manual match',
  'COMMUNICATION.RequestGroup_SectionUnidentifiedHint' : 'These items require manual clarification before confirmation can continue.',
  'COMMUNICATION.RequestGroup_SectionQuestions' : 'Questions from email',
  'COMMUNICATION.RequestGroup_SectionQuestionsHint' : 'These questions stay visible during review because they may affect the final changes.',
  'COMMUNICATION.RequestGroup_Confidence' : '{ count }% confidence',
  'COMMUNICATION.RequestGroup_ItemNotes' : 'Notes: { note }',
  'COMMUNICATION.Concept_OriginalEmailHint' : 'The original email stays visible as the primary source context for manager review.',
  'COMMUNICATION.Concept_MultiGroupHint' : 'This email already contains multiple parsed stand groups. The current concept keeps the parent email intact and surfaces child groups below.',
  'COMMUNICATION.Concept_WorkStateNote' : 'Persistent ownership, locking, and last-touch metadata require backend support and are shown here only as concept state.',
  'COMMUNICATION.Concept_FutureActionsTitle' : 'Project context and reply actions',
  'COMMUNICATION.Concept_OpenInMyStandTitle' : 'Open project context',
  'COMMUNICATION.Concept_OpenInMyStandNote' : 'The real action will open the correct stand or project in myStand after route-contract data is available from backend.',
  'COMMUNICATION.Concept_ReplyTitle' : 'Reply workflow',
  'COMMUNICATION.Concept_ReplyNote' : 'Reply, thread context, and send flow are concept placeholders until backend email actions are connected.',
  'COMMUNICATION.Concept_FutureActionsHint' : 'These actions are shown to validate the future workflow shape. They remain disabled until API support exists.',
  'COMMUNICATION.QuestionsWorkflow_Label' : 'Communication follow-up',
  'COMMUNICATION.QuestionsWorkflow_Title' : 'Customer clarification',
  'COMMUNICATION.QuestionsWorkflow_Hint' : 'Use project context and customer reply when the email needs clarification before review continues.',
  'COMMUNICATION.QuestionsWorkflow_Step2Hint' : 'If customer follow-up is needed, continue with the reply draft in step 2.',
  'COMMUNICATION.QuestionsWorkflow_RelatedStand' : 'Related stand { stand }',
  'COMMUNICATION.QuestionsWorkflow_ClarificationNeeded' : 'Needs follow-up',
  'COMMUNICATION.QuestionsWorkflow_AffectsChanges' : 'May affect changes',
  'COMMUNICATION.QuestionsWorkflow_Step2Continue' : 'Continue in step 2',
  'COMMUNICATION.QuestionsWorkflow_ApiPending' : 'API pending',
  'COMMUNICATION.QuestionsWorkflow_Note' : 'Actions will be enabled after backend integration.',
  'COMMUNICATION.Step2Summary_ChangesLabel' : 'Changes to review',
  'COMMUNICATION.Step2Summary_ClarificationsLabel' : 'Clarifications',
  'COMMUNICATION.Step2Summary_StandsLabel' : 'Stand groups',
  'COMMUNICATION.Step1Summary_StandsLabel' : 'Stands detected',
  'COMMUNICATION.Step1Summary_ParserConfidenceLabel' : 'Parser confidence',
  'COMMUNICATION.Step1Summary_UnresolvedLabel' : 'Unresolved items',
  'COMMUNICATION.Step1Summary_UnresolvedHint' : '{ count } need manual review',
  'COMMUNICATION.Step1Summary_UnresolvedClear' : 'All parsed items are reviewable',
  'COMMUNICATION.Step1Summary_ClarificationsLabel' : 'Clarifications',
  'COMMUNICATION.QuestionCard_Label' : 'Customer clarification',
  'COMMUNICATION.QuestionCard_Hint' : 'Resolve the clarification before final approval if it affects the equipment set.',
  'COMMUNICATION.QuestionCard_ImpactHint' : 'Resolve before final approval if it may affect the equipment set.',
  'COMMUNICATION.QuestionCard_AffectsChanges' : 'May affect changes',
  'COMMUNICATION.QuestionCard_FollowUp' : 'Customer follow-up',
  'COMMUNICATION.QuestionCard_RelatedStand' : 'Related stand { stand }',
  'COMMUNICATION.QuestionCard_RelatedStands' : '{ count } related stands',
  'COMMUNICATION.QuestionCard_WhyLabel' : 'Why it matters',
  'COMMUNICATION.QuestionCard_RequestLabel' : 'Customer message',
  'COMMUNICATION.QuestionCard_StatusLabel' : 'Clarification status',
  'COMMUNICATION.HandoffNote_Title' : 'Reply to customer',
  'COMMUNICATION.HandoffNote_Hint' : 'Prepare the customer-facing reply here. Quick replies can prefill the draft before you open it in your mail app.',
  'COMMUNICATION.HandoffNote_Placeholder' : 'Draft the customer-facing reply here. This text will be opened in the mail app draft.',
  'COMMUNICATION.HandoffNote_Add' : 'Add customer reply draft',
  'COMMUNICATION.HandoffNote_StatusPrepared' : 'Draft ready',
  'COMMUNICATION.HandoffNote_StatusEmpty' : 'No draft yet',
  'COMMUNICATION.HandoffNote_SummaryTitle' : 'Reply to customer',
  'COMMUNICATION.HandoffNote_SummaryHint' : 'This draft stays read-only here so the next customer follow-up has clear context.',
  'COMMUNICATION.HandoffNote_EmptyPreview' : 'No customer reply draft was prepared.',
  'COMMUNICATION.FinalFollowUp_Title' : 'Customer follow-up',
  'COMMUNICATION.FinalFollowUp_Hint' : 'Shows the prepared reply draft and whether customer follow-up is still needed after approval.',
  'COMMUNICATION.ReplyDraft_QuickReplies' : 'Quick replies',
  'COMMUNICATION.ReplyDraft_To' : 'To',
  'COMMUNICATION.ReplyDraft_Subject' : 'Subject',
  'COMMUNICATION.ReplyDraft_OpenMailApp' : 'Open reply draft',
  'COMMUNICATION.ReplyDraft_OpenMailAppHint' : 'Opens your default mail app with the current reply draft.',
  'COMMUNICATION.ReplyDraft_TemplateAvailable' : 'Available',
  'COMMUNICATION.ReplyDraft_TemplateUnavailable' : 'Not available',
  'COMMUNICATION.ReplyDraft_TemplateUnderReview' : 'Under review',
  'COMMUNICATION.ReplyDraft_TextAvailable' : 'Hello,\n\nWe checked your request and confirm it is available.\n\nBest regards',
  'COMMUNICATION.ReplyDraft_TextUnavailable' : 'Hello,\n\nWe checked your request and confirm it is currently not available.\n\nBest regards',
  'COMMUNICATION.ReplyDraft_TextUnderReview' : 'Hello,\n\nWe are reviewing your request and will confirm shortly.\n\nBest regards',
  'COMMUNICATION.ReplyDraft_RecipientMissing' : 'No sender email available',
  'COMMUNICATION.NotRelevant_Title' : 'Mark email as not relevant',
  'COMMUNICATION.NotRelevant_Hint' : 'Use this when the email is spam, informational only, sent to the wrong recipient, or has no usable project context. It will leave the active queues and stay in history with a reason.',
  'COMMUNICATION.NotRelevant_HintWithExtractedData' : 'This email already contains extracted changes or questions, but Step 1 still cannot be completed. Use this only if you want to stop processing it and move it out of the active queues.',
  'COMMUNICATION.NotRelevant_ReasonLabel' : 'Reason',
  'COMMUNICATION.NotRelevant_Confirm' : 'Move to history',
  'COMMUNICATION.NotRelevantReason_spam_marketing' : 'Spam / marketing',
  'COMMUNICATION.NotRelevantReason_no_project_context' : 'No project context',
  'COMMUNICATION.NotRelevantReason_wrong_recipient' : 'Wrong recipient',
  'COMMUNICATION.NotRelevantReason_informational_only' : 'Informational only',
  'COMMUNICATION.Button_ViewStandDrawing' : 'View stand drawing',
  'COMMUNICATION.CadPreview_Hint' : 'The CAD preview will open here when stand drawing data is available.',
  'COMMUNICATION.NextAction_Title' : 'Next action after approval',
  'COMMUNICATION.NextAction_Hint' : 'Shows whether approval can finish the workflow or whether customer follow-up is still expected.',
  'COMMUNICATION.NextAction_NoFollowUpNeeded' : 'No follow-up needed',
  'COMMUNICATION.NextAction_FollowUpNeeded' : 'Customer follow-up needed',
  'COMMUNICATION.StepHint_RequiredFields' : 'Required: { fields }',
  'COMMUNICATION.StepHint_AIPendingCount' : '{ count } AI pending',
  'COMMUNICATION.StepHint_CatalogMatchCount' : '{ count } need catalog match',
  'COMMUNICATION.StepHint_OpenQuestionsCount' : '{ count } open questions',
  'COMMUNICATION.StepHint_ChangesDone' : 'All rows reviewed',
  'COMMUNICATION.StepHint_NoExtractedChanges' : 'No extracted changes found for this email.',
  'COMMUNICATION.StepHint_NoPendingChanges' : 'No pending changes. You can continue.',
  'COMMUNICATION.Field_StandNumbers' : 'Stand numbers',
  'COMMUNICATION.Hint_MultiStandMatching' : 'This email contains multiple parsed stand groups. Confirm each stand here before continuing.',
  'COMMUNICATION.Button_AddStandNumber' : 'Add stand',
  'COMMUNICATION.StepAction_ContinueMatching' : 'Complete matching to continue.',
  'COMMUNICATION.StepAction_ApproveMatching' : 'Complete matching before approval.',
  'COMMUNICATION.Step_Confirm_Title' : '4. Approve',
  'COMMUNICATION.Step_Confirm_Help' : 'Approve the cleaned result when the assignment and changes are correct.',
  'COMMUNICATION.Empty_Inbox' : 'No open emails',
  'COMMUNICATION.Empty_Pending' : 'No emails ready to confirm',
  'COMMUNICATION.Empty_Unidentified' : 'No emails that need matching',
  'COMMUNICATION.Empty_Audit' : 'No processed items',
  'COMMUNICATION.Action_Add' : 'Add',
  'COMMUNICATION.Action_Remove' : 'Remove',
  'COMMUNICATION.Action_Change' : 'Change',
  'COMMUNICATION.Action_Question' : 'Question',
  'COMMUNICATION.Relative_JustNow' : 'just now',
  'COMMUNICATION.Relative_MinutesAgo' : '{ count } min ago',
  'COMMUNICATION.Relative_HoursAgo' : '{ count }h ago',
  'COMMUNICATION.Relative_Today' : 'today',
  'COMMUNICATION.Relative_Yesterday' : 'yesterday',
  'COMMUNICATION.PageTitle' : 'Communication Board',
  'TEAM_ROLES.project_manager' : 'Project manager',
  'TEAM_ROLES.construction_manager' : 'Construction manager',
  'TEAM_ROLES.draftsmen' : 'Autocad engineer',
};

export default english;
